
<template>
  <b-container fluid>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title">{{ $t('external_sidebar.candidate_applicant_list') }} {{ $t('globalTrans.search') }}</h4>
      </template>
      <template v-slot:body>
        <b-row>
            <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                <b-form-group
                    class="row"
                    label-cols-sm="4"
                    :label="$t('retailerManagement.year')"
                    label-for="registration_year"
                    >
                    <b-form-select
                    plain
                    v-model="search.registration_year"
                    :options="yearList"
                    id="year"
                    >
                    <template v-slot:first>
                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                    </template>
                    </b-form-select>
                </b-form-group>
            </b-col>
           <b-col xs="12" sm="12" md="4" lg="4" xl="4">
             <b-form-group
                 class="row"
                 label-cols-sm="4"
                 :label="$t('externalUser.disability_types')"
                 label-for="disable_type_id"
             >
               <b-form-select
                   plain
                   :options="disabilityTypeList"
                   v-model="search.disable_type_id"
                   id="disable_type_id"
               >
                 <template v-slot:first>
                   <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                 </template>
               </b-form-select>
             </b-form-group>
           </b-col>
           <b-col xs="12" sm="12" md="4" lg="4" xl="4">
             <b-form-group
                 class="row"
                 label-cols-sm="4"
                 :label="$t('globalTrans.name')"
                 label-for="patient_id"
             >
               <b-form-select
                   plain
                   :options="patientList"
                   v-model="search.patient_id"
                   id="patient_id"
               >
                 <template v-slot:first>
                   <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                 </template>
               </b-form-select>
             </b-form-group>
           </b-col>
          <b-col xs="12" sm="12" md="4" lg="4" xl="4">
            <ValidationProvider name="Circular Title" vid="education_level_id">
                <b-form-group
                    class="row"
                    label-cols-sm="4"
                    label-for="education_level_id"
                >
                <template v-slot:label>
                    {{ $t('awareness_config.education_level')}}
                </template>
                <b-form-select
                    plain
                    v-model="search.education_level_id"
                    :options="educationLevelList"
                    id="education_level_id"
                >
                    <template v-slot:first>
                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                    </template>
                </b-form-select>
              </b-form-group>
            </ValidationProvider>
          </b-col>
          <b-col xs="12" sm="12" md="4" lg="4" xl="4">
            <ValidationProvider name="Division" vid="division_id" rules="required|min_value:1">
              <b-form-group
                  class="row"
                  label-cols-sm="4"
                  label-for="division_id"
                  slot-scope="{ valid, errors }"
              >
                <template v-slot:label>
                  {{$t('org_pro_division.division')}}
                </template>
                <b-form-select
                    plain
                    v-model="search.division_id"
                    :options="divisionList"
                    id="division_id"
                    :state="errors[0] ? false : (valid ? true : null)"
                >
                  <template v-slot:first>
                    <b-form-select-option value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                  </template>
                </b-form-select>
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </b-form-group>
            </ValidationProvider>
          </b-col>
          <b-col xs="12" sm="12" md="4" lg="4" xl="4">
            <ValidationProvider name="District" vid="district_id" rules="required|min_value:1">
              <b-form-group
                  class="row"
                  label-cols-sm="4"
                  label-for="district_id"
                  slot-scope="{ valid, errors }"
              >
                <template v-slot:label>
                  {{$t('org_pro_district.district')}}
                </template>
                <b-form-select
                    plain
                    v-model="search.district_id"
                    :options="districtList"
                    id="district_id"
                    :state="errors[0] ? false : (valid ? true : null)"
                >
                  <template v-slot:first>
                    <b-form-select-option value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                  </template>
                </b-form-select>
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </b-form-group>
            </ValidationProvider>
          </b-col>
        </b-row>
        <b-row>
          <b-col xs="12" sm="12" md="6" lg="6" xl="6">
            <b-button type="button" variant="primary" @click="searchData">{{ $t('globalTrans.search') }}</b-button>
          </b-col>
        </b-row>
      </template>
    </iq-card>
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('external_sidebar.candidate_applicant_list') }}</h4>
          </template>
          <template v-slot:body>
            <b-overlay :show="loadingState">
              <b-row>
                <b-col md="12" class="table-responsive">
                  <b-table thead-class="bg-primary" bordered hover :items="data" :fields="columns" aria-hidden="loading | listReload ? 'true' : null" :emptyText="$t('globalTrans.noDataFound')" show-empty>
                    <template v-slot:cell(index)="data">
                      {{ $n(data.index + pagination.slOffset) }}
                    </template>
                    <template v-slot:cell(application_id)="data">
                      {{ $n(data.item.application_id, { useGrouping: false   }) }}
                    </template>
                    <template v-slot:cell(mobile)="data">
                      {{ $n(data.item.mobile, { useGrouping: false   }) }}
                    </template>
                    <template v-slot:cell(registration_date)="data">
                      {{ data.item.registration_date|dateFormat }}
                    </template>
                    <template v-slot:cell(gender)="data">
                      {{ getGenderName(data.item.gender) }}
                    </template>
                    <template v-slot:cell(disability_types)="data">
                      {{ getDisabilityTypeNameList(data.item.disability_types) }}
                    </template>
                     <template v-slot:cell(status)="data">
                       <span class="badge badge-warning" v-if="data.item.status == 2">{{ $t('event_manage.approved') }}</span>
                       <span class="badge badge-primary" v-if="data.item.status == 1">{{ $t('event_manage.pending') }}</span>
                    </template>
                   <template v-slot:cell(action)="data">
                      <!-- <router-link title="View CV" :to="`/awareness-event-service/job-fair-management/applicant-list-details?patient_id=${data.item.patient_id}`" class="btn btn-sm btn-info mr-1"><i class="ri-eye-line m-0 "></i></router-link> -->
                      <router-link title="View CV" :to="`/awareness-event-service/job-fair-management/cv-bank-details?id=${data.item.patient_id}`" class="btn btn-sm btn-info ml-2"><i class="ri-eye-line m-0 "></i></router-link>
                        <!-- <b-button :variant="data.item.status === 2 ? ' iq-bg-danger' : ' iq-bg-success'" size="sm" title="Active/Deactive" @click="toggleStatus(data.item)">
                          <i class="fas" :class="data.item.status === 2  ? 'fa-toggle-off' : 'fa-toggle-on'"></i>
                        </b-button> -->
                        <b-button title="Approved" v-if="data.item.status === 1" variant="iq-bg-success mr-1 mb-1" class="btn btn-sm btn-success" size="md" @click="processing(data.item)"><i class="fa fa-check" aria-hidden="true"></i></b-button>
                    </template>
                  </b-table>
                  <b-pagination
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total-rows="pagination.totalRows"
                    @input="searchData"
                    />
                </b-col>
              </b-row>
            </b-overlay>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>

import RestApi, { awarenessEventServiceBaseUrl } from '@/config/api_config'
import { applicantList, applicantToggleStatus } from '../../api/routes'
import ModalBaseMasterList from '@/mixins/modal-base-master-list'
import flatpickr from 'flatpickr'
import Store from '@/store'
import { helpers } from '@/mixins/helper-functions'

export default {
  mixins: [ModalBaseMasterList],
   components: {
  },
  data () {
    return {
      search: {
        registration_year: new Date().getFullYear(),
        disable_type_id: 0,
        education_level_id: 0,
        patient_id: 0,
        division_id: 0,
        district_id: 0
      },
      rows: [],
      editItemId: 0,
      item: '',
      data: [],
      yearList: [],
      isRetailer: false,
      ItemShow: false,
      districtList: [],
      upazilaList: []
    }
  },
  computed: {
    i18 () {
      return (this.$i18n.locale === 'bn') ? 1 : 0
    },
    fiscalYearList: function () {
      return this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0)
    },
    registrationTypeList: function () {
        return this.$store.state.ProductionService.commonObj.registrationTypeList
    },
    currentLocale () {
      return this.$i18n.locale
    },
    disabilityTypeList () {
      return this.$store.state.AwarenessEventService.commonObj.disabilityTypeList
    },
    educationLevelList: function () {
        return this.$store.state.AwarenessEventService.commonObj.educationLevelList
    },
    patientList () {
      return this.$store.state.AwarenessEventService.commonObj.patientList
    },
    divisionList: function () {
      return this.$store.state.commonObj.divisionList.filter(item => item.status === 0)
    },
    columns () {
      const labels = [
          { label: this.$t('globalTrans.sl_no'), class: 'text-center' },
          { label: this.$t('externalUser.registration_id'), class: 'text-center' },
          { label: this.$t('externalUser.registration_date'), class: 'text-center' },
          { label: this.$t('admission_management.circular_name'), class: 'text-center' },
          { label: this.$t('retailerManagement.name'), class: 'text-left' },
          { label: this.$t('externalUser.mobile_no'), class: 'text-center' },
          { label: this.$t('globalTrans.gender'), class: 'text-center' },
          { label: this.$t('event_manage.disable_type'), class: 'text-center' },
          { label: this.$t('job_fair_management.highest_education'), class: 'text-center' },
          { label: this.$t('globalTrans.status'), class: 'text-left' },
          { label: this.$t('globalTrans.action'), class: 'text-left action', thStyle: { width: '15%' } }
        ]

      let keys = []

      if (this.$i18n.locale === 'bn') {
        keys = [
          { key: 'index' },
          { key: 'application_id' },
          { key: 'registration_date' },
          { key: 'title_bn' },
          { key: 'name_bn' },
          { key: 'mobile' },
          { key: 'gender' },
          { key: 'disability_types' },
          { key: 'education_bn' },
          { key: 'status' },
          { key: 'action' }
        ]
      } else {
        keys = [
         { key: 'index' },
          { key: 'application_id' },
          { key: 'registration_date' },
          { key: 'title_en' },
          { key: 'name' },
          { key: 'mobile' },
          { key: 'gender' },
          { key: 'disability_types' },
          { key: 'education' },
          { key: 'status' },
          { key: 'action' }
        ]
      }

      return labels.map((item, index) => {
          return Object.assign(item, keys[index])
        })
    }
  },
  watch: {
    'search.division_id': function (newVal, oldVal) {
      this.districtList = this.getDistrictList(newVal)
    }
  },
  created () {
    this.loadData()
    this.getYearOptions()
  },
  mounted () {
    flatpickr('.date-picker', {})
  },
  methods: {
    getGenderName (Id) {
        const tmpData = this.$store.state.commonObj.genderList.find(item => item.value === parseInt(Id))
        if (this.$i18n.locale === 'bn') {
            return tmpData.text_bn
        } else {
            return tmpData.text_en
        }
    },
    // toggleStatus (item) {
    //     this.changeStatus(awarenessEventServiceBaseUrl, applicantToggleStatus, item)
    // },
    changeStatus (baseUrl, uri, item, destination = null, dropdownName = null) {
      Store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
      RestApi.deleteData(baseUrl, `${uri}/${item.id}`).then(response => {
      if (response.success) {
          if (destination !== null && dropdownName !== null) {
          Store.dispatch('toggleDropdownItemStatus', { itemId: item.id, destination: destination, dropdownName: dropdownName })
          }
          window.vm.$toast.success({
          title: 'Success',
          message: 'Applicant Confirmed Successfully',
          color: '#D6E09B'
          })
      } else {
          window.vm.$toast.error({
          title: 'Error',
          message: 'Operation failed! Please, try again.'
          })
      }
      Store.dispatch('mutateCommonProperties', { loading: false, listReload: true })
      })
    },
    processing (item) {
        window.vm.$swal({
            title: window.vm.$t('job_fair_management.confirm_data'),
            showCancelButton: true,
            confirmButtonText: window.vm.$t('globalTrans.yes'),
            cancelButtonText: window.vm.$t('globalTrans.no'),
            focusConfirm: false
        }).then((result) => {
            if (result.isConfirmed) {
                this.changeStatus(awarenessEventServiceBaseUrl, applicantToggleStatus, item)
            }
        })
    },
    searchData () {
      this.loadData()
    },
    async loadData () {
      const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })
      this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
      await RestApi.getData(awarenessEventServiceBaseUrl, applicantList, params).then(response => {
          if (response.success) {
            this.data = this.getCustomDataList(response.data.data)
          }
          this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
      })
    },
    getCustomDataList (data) {
      const listData = data.map(item => {
        const educationList = this.educationLevelList.find(type => type.value === item.education_level_id)
          const educationData = {
            education: educationList !== undefined ? educationList.text_en : '',
            education_bn: educationList !== undefined ? educationList.text_bn : ''
          }
        return Object.assign({}, item, educationData)
      })
      return listData
    },
    getYearOptions (startYear) {
      this.yearList = helpers.getYearList()
      return this.yearList
    },
    getDistrictList (divisionId = null) {
      const districtList = this.$store.state.commonObj.districtList.filter(item => item.status === 0)

      if (divisionId) {
        return districtList.filter(district => district.division_id === divisionId)
      }

      return districtList
    },
    getDisabilityTypeNameList (disabilityTypes) {
      const arr = []
      disabilityTypes = JSON.parse(disabilityTypes)
      disabilityTypes.forEach(item => {
        try {
        const disabilityType = this.disabilityTypeList.find(obj => obj.value === item)
        const disabilityTypeName = this.currentLocale === 'en' ? disabilityType.text_en : disabilityType.text_bn
        arr.push(disabilityTypeName)
        } catch (e) {
        }
      })
      return arr.toString()
    },
    pdfExport () {
      this.$refs.details.pdfExport()
    }
  }
}
</script>
<style>
.action {
  max-width: 12%
}
.modal-title {
  flex-grow: 1 !important;
}
</style>
